{
  "actions": "Ações",
  "actionsAvailable": "Ações disponíveis.",
  "clearSelection": "Limpar seleção",
  "selected": "{count, plural, =0 {Nada selecionado} other {# selecionado}}",
  "selectedAll": "Todos selecionados"
}
